import { MDXLayout as Layout } from "@/shared/components/MDX/MDXLayout";

# راهنمای ثبت بازرسی جدید (Create Inspection Record)

این فرم برای ثبت نتایج یک بازرسی کیفی جدید استفاده می‌شود. طراحی این صفحه دقیقاً مشابه استایل و فرمت صفحات خطوط تولید (Production Lines) انجام شده است تا یکپارچگی تجربه کاربری حفظ شود.

## نحوه ثبت
۱. **انتخاب هدف بازرسی:** ابتدا نوع هدف (مانند سفارش تولید یا تراکنش انبار) و شناسه مربوطه را انتخاب کنید.
۲. **تعیین نتیجه:** نتیجه بازرسی را (قبول یا رد) مشخص کنید.
۳. **ثبت یادداشت‌ها:** در صورت نیاز، توضیحات و یادداشت‌های مربوط به این بازرسی را وارد نمایید.
۴. در نهایت با تایید فرم، بازرسی با تاریخ و زمان فعلی ثبت می‌شود.

export default function Page({ children }) {
  return <Layout>{children}</Layout>;
}
